/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogStringEntry
 */
export interface LogStringEntry {
    /**
     * 
     * @type {string}
     * @memberof LogStringEntry
     */
    value: string;
    /**
     * 
     * @type {number}
     * @memberof LogStringEntry
     */
    step?: number;
    /**
     * 
     * @type {number}
     * @memberof LogStringEntry
     */
    timestampMilliseconds: number;
}

/**
 * Check if a given object implements the LogStringEntry interface.
 */
export function instanceOfLogStringEntry(value: object): value is LogStringEntry {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('timestampMilliseconds' in value) || value['timestampMilliseconds'] === undefined) return false;
    return true;
}

export function LogStringEntryFromJSON(json: any): LogStringEntry {
    return LogStringEntryFromJSONTyped(json, false);
}

export function LogStringEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogStringEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'step': json['step'] == null ? undefined : json['step'],
        'timestampMilliseconds': json['timestampMilliseconds'],
    };
}

export function LogStringEntryToJSON(value?: LogStringEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'step': value['step'],
        'timestampMilliseconds': value['timestampMilliseconds'],
    };
}

